import React, { lazy } from 'react'
import { Route } from 'react-router-dom'
import { Info } from 'lucide-react'
import { ProtectedRoute } from '@/components/ProtectedRoute'
import { lazyRoute } from '../routeHelpers'
import type { FrontendFeature } from '../types'

const AboutPage = lazy(() => import('./pages/AboutPage').then((m) => ({ default: m.AboutPage })))

const feature: FrontendFeature = {
  navItems: [
    { path: '/about', label: 'About', icon: Info },
  ],
  routes: [
    <Route
      key="about"
      path="/about"
      element={
        <ProtectedRoute>{lazyRoute(<AboutPage />)}</ProtectedRoute>
      }
    />,
  ],
}

export default feature
